<template>
  <v-app>
    <transition name="fade-slide" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
  </v-app>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'App',
});
</script>

<style>
/* ---------------------------------------------------------------------------
 * Global page transition (signup -> qualify, login -> signup, etc.)
 * Uses cubic-bezier for natural easing. 280ms feels snappy without being
 * jarring. Honors prefers-reduced-motion at the bottom of this file.
 * ------------------------------------------------------------------------ */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition:
    opacity 0.28s cubic-bezier(0.2, 0.8, 0.2, 1),
    transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1);
}
.fade-slide-enter,
.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(8px);
}

/* ---------------------------------------------------------------------------
 * Global reduced-motion override. Whenever the OS reports the user prefers
 * reduced motion, kill animations + transitions across the entire auth shell.
 * ------------------------------------------------------------------------ */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
</style>
